import { render, staticRenderFns } from "./RsaSchedaRelazioneSanitariaAnamnesiFamiliareEditComponent.vue?vue&type=template&id=1bbe98fc"
import script from "./RsaSchedaRelazioneSanitariaAnamnesiFamiliareEditComponent.vue?vue&type=script&lang=js"
export * from "./RsaSchedaRelazioneSanitariaAnamnesiFamiliareEditComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports